import { useQuery } from '@tanstack/react-query';
import { ForeignAmountsPreviewOutput, ForeignAmountsPreviewQuery } from './types';
import { getForeignAmountsPreview } from './getForeignAmountsPreview';

export function useForeignAmountsPreviewQuery(props: ForeignAmountsPreviewQuery) {
  return useQuery<ForeignAmountsPreviewOutput>({
    queryKey: ['foreign-amounts-preview', props.companyId, props.driverId, props.yearMonth],
    queryFn: async () => {
      const { data } = await getForeignAmountsPreview(props)
      return data;
    },
    enabled: !!props.companyId && !!props.driverId && !!props.yearMonth,
    // Snapshot written by the timesheet calculation — see useAmountsPreviewQuery.
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
